import { useFeatureFlag as harnessFeatureFlag } from '@harnessio/ff-react-client-sdk';

export const useConferenceManagement = () => {
  const featureFlag = harnessFeatureFlag('APP2315_Chancellor_Conference_Management', false);
  return featureFlag;
};
